import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { TextField } from "@website/ui/text-field";
import { usePasswordField } from "@website/widget/password-field/password-field.hook";
import styles from "@website/widget/password-field/password-field.module.scss";
import { PasswordFieldPropertiesType } from "@website/widget/password-field/password-field.types";
import { FC } from "react";
export const PasswordField: FC<PasswordFieldPropertiesType> = properties => {
  const $ = _c(17);
  const {
    error,
    helperText,
    placeholder,
    hideConditions,
    autoFocus
  } = properties;
  const {
    password,
    onChangePassword,
    conditionErrors,
    toggleVisibility,
    visibility
  } = usePasswordField(properties);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MaterialIcon name="remove_red_eye" />;
    t1 = <MaterialIcon name="lock" variant="outlined" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  const t2 = visibility ? "text" : "password";
  let t3;
  if ($[2] !== autoFocus || $[3] !== error || $[4] !== helperText || $[5] !== onChangePassword || $[6] !== password || $[7] !== placeholder || $[8] !== t2 || $[9] !== toggleVisibility) {
    t3 = <TextField EndIcon={t0} StartIcon={t1} error={error} fullWidth={true} helperText={helperText} onChange={onChangePassword} onEndIconClick={toggleVisibility} placeholder={placeholder} type={t2} value={password} autoFocus={autoFocus} />;
    $[2] = autoFocus;
    $[3] = error;
    $[4] = helperText;
    $[5] = onChangePassword;
    $[6] = password;
    $[7] = placeholder;
    $[8] = t2;
    $[9] = toggleVisibility;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== conditionErrors || $[12] !== hideConditions) {
    t4 = hideConditions ? null : <div className={styles.conditions}><div className={`${styles["condition-item"]} ${conditionErrors.useEnglishCharacter ? "" : styles.checked}`}>{conditionErrors.useEnglishCharacter ? <MaterialIcon name="remove" /> : <MaterialIcon name="check_circle" />}استفاده از حروف انگلیسی</div><div className={`${styles["condition-item"]} ${conditionErrors.useNumberCharacter ? "" : styles.checked}`}>{conditionErrors.useNumberCharacter ? <MaterialIcon name="remove" /> : <MaterialIcon name="check_circle" />}استفاده از عدد</div><div className={`${styles["condition-item"]} ${conditionErrors.useSpecialCharacter ? "" : styles.checked}`}>{conditionErrors.useSpecialCharacter ? <MaterialIcon name="remove" /> : <MaterialIcon name="check_circle" />}{"\u0627\u0633\u062A\u0641\u0627\u062F\u0647 \u0627\u0632 \u06A9\u0627\u0631\u0627\u06A9\u062A\u0631 \u0647\u0627\u06CC \u062E\u0627\u0635 (@#$&*! \u0648 ...)"}</div><div className={`${styles["condition-item"]} ${conditionErrors.reachMinimumCharactersLength ? "" : styles.checked}`}>{conditionErrors.reachMinimumCharactersLength ? <MaterialIcon name="remove" /> : <MaterialIcon name="check_circle" />}حداقل ۸ کاراکتر</div></div>;
    $[11] = conditionErrors;
    $[12] = hideConditions;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t3 || $[15] !== t4) {
    t5 = <div className={styles.container}>{t3}{t4}</div>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};